module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-actions"
  }, [_vm._l((_vm.headerActions), function(action) {
    return [(action.routerLinkTo) ? _c('router-link', {
      staticClass: "page-action",
      attrs: {
        "to": action.routerLinkTo
      }
    }, [(action.html) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(action.html)
      }
    }) : _vm._e(), _vm._v(_vm._s(action.text))]) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67fb98b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Actions.vue
// module id = 479
// module chunks = 2